import type { LegalDocumentType } from '@backmarket/http-api/src/api-specs-seller-backoffice/seller-profile'
import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types'

import translations from './LegalDocuments.translations'

export const DOCUMENT_DESCRIPTIONS: Partial<
  Record<LegalDocumentType, I18nDefinition>
> = {
  IDENTITY_CARD: translations.identityCard,
  BANKING_INFORMATION: translations.KBIS,
}
